import { Component } from '@angular/core';
import { CustomRadioButtonComponent } from '../Utility/custom-radio-button/custom-radio-button.component';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
    selector: 'app-questionnaire',
    imports: [
        CustomRadioButtonComponent,
        FormsModule,
    ],
    templateUrl: './questionnaire.component.html',
    styleUrl: './questionnaire.component.scss'
})
export class QuestionnaireComponent {
  responses: string[] = []
  yesNoButtons = [
    {label: "Yes", value: "1"},
    {label: "No", value: "2"},
  ]

  constructor(private router: Router) { }

  appointmentIsInScope() {
    const outOfScope = this.responses[1] == '1'
            || this.responses[2] == '1'
            || this.responses[4] == '1'
            || this.responses[5] == '1'
            || this.responses[6] == '1'
            || this.responses[7] == '1'
            || this.responses[8] == '1'
            || this.responses[9] == '1'
            || this.responses[15] == '1'
    
    return !outOfScope;
  }

  scheduleAppointment() {
    this.router.navigate(['/signup'])
  }
}
